export const DISABLED_MESSAGES = {
  status: {
    cancelled: "Cancelled tasks cannot have their status changed.",
    complete: "Use Reopen from task overview to change status.",
    crossTeamAssigned: "Status is controlled by the assignee team.",
  },
  assigneeTeam: {
    cancelled: "Cannot be changed on a cancelled task.",
    ownerOnly: "Only the owner team can change the assignee team.",
    ownerAssigned: "Cannot be changed after an owner has been assigned.",
  },
  assigneeOwner: {
    wrongTeam: "Only the assignee team can set the assignee owner.",
  },
  reopen: {
    notComplete: "Only completed tasks can be reopened.",
    wrongTeam: "Only the owner team or assignee team can reopen tasks.",
  },
  changeStatus: {
    cancelled: "Cancelled tasks cannot have their status changed.",
    complete:
      "Complete tasks cannot have their status changed. Use Reopen instead.",
  },
  delete: {
    hasAssigneeOwner:
      "Cannot delete: this task has an assignee owner. Clear the assignee owner before deleting.",
  },
  deleteTaskGroup: {
    hasAssigneeOwnerInTasks:
      "This task group has tasks with an assignee owner. Clear the assignee owner on those tasks before deleting the group.",
  },
  requestReview: {
    reviewExists:
      "A review already exists for this resource. To request a new one, contact the existing review's requester or approvers to delete the current review.",
  },
};
